window.CHECK_IS_CHRISTMAS_THEME = () => {
  const now = new Date();
  return (
    now.getMonth() === 11 && // December
    now.getDate() <= 25 && // between [1, 25]
    now.getDate() >= 1
  );
};
window._IS_CHRISTMAS_THEME = window.CHECK_IS_CHRISTMAS_THEME(); // eslint-disable-line
